// extracted by mini-css-extract-plugin
export var root = "_3egR";
export var rootArrow = "+Ss+";
export var rootArrowNext = "_4Fla";
export var rootArrowPrev = "V2oF";
export var rootArrows = "nHD+";
export var rootButton = "c7HU";
export var rootButtons = "Yhdc";
export var rootCaption = "_5oWC";
export var rootContainer = "cLwq";
export var rootContent = "_1XM4";
export var rootContentWrapper = "fXMM";
export var rootCopy = "AUJD";
export var rootDescription = "RQaM";
export var rootHeading = "_7o2N";
export var rootMedia = "_9ZlH";
export var rootMediaImage = "TVyH";
export var rootStat = "b2Ac";
export var rootStatDescription = "UM8W";
export var rootStatValue = "yEBZ";
export var rootStats = "JIMu";
export var rootSubheading = "gEPd";
export var rootTab = "F8Bt";
export var rootTabActive = "_0hwo";
export var rootTabs = "oQ4o";
export var rootTabsRow = "L8Yd";
export var rootTitle = "wSx+";